import type { Graph } from '@metro/graph'
import { EdgeType } from '@metro/graph'

/**
 * The station pairs a single ride edge joins, for
 * `ruleNoIndirectTransferWhenDirectExists`: the rule asked the whole edge
 * list once per ride → change → ride triple of every candidate path, which
 * made it a scan of the graph per path. Built once per graph
 * (`Graph.derived`). iOS twin: `RideLinks.swift`.
 */
export interface RideLinks {
  /** Whether a ride edge leads from station `from` to station `to`. */
  connects(from: string, to: string): boolean
}

export function rideLinksOf(graph: Graph): RideLinks {
  return graph.derived('routing.rideLinks', build)
}

function build(graph: Graph): RideLinks {
  const byFrom = new Map<string, Set<string>>()
  for (const e of graph.allEdges()) {
    if (e.type !== EdgeType.Ride) continue
    const targets = byFrom.get(e.from.id)
    if (targets) targets.add(e.to.id)
    else byFrom.set(e.from.id, new Set([e.to.id]))
  }
  return { connects: (from, to) => byFrom.get(from)?.has(to) === true }
}
